import React, { Component } from 'react';

import Container from 'components/container';
import SignUpForm from './SignUpForm';
import OnboardingStore from 'modules/onboarding/OnboardingStore';

import './SignUpPage.css';

class SignUpPage extends Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.state.signUpState = OnboardingStore.getSignUpState();
    }

    componentWillMount = () => {
        OnboardingStore.on('change', this.onSignUpStateChange);
    };

    componentWillUnmount = () => {
        OnboardingStore.removeListener('change', this.onSignUpStateChange);
    };

    onSignUpStateChange = () => {
        console.log('onSignupStateChange', {
            signUpState: OnboardingStore.getSignUpState()
        });
        this.setState({ signUpState: OnboardingStore.getSignUpState() });
    };

    render() {
        return (
            <div className="sign-up-page page">
                <Container transparent fluid>
                    <div className="sign-up-form-wrapper">
                        <SignUpForm signUpState={this.state.signUpState} />
                    </div>
                </Container>
            </div>
        );
    }
}

export default SignUpPage;



// WEBPACK FOOTER //
// ./src/modules/onboarding/pages/signup/SignUpPage.jsx